import { logger } from '@ubeeqo/web-utils';

function resolveNavigatorGeolocaiton(resolve) {
  const whenGeolocationIsEnabled = (position) => {
    // When geolocation is enabled
    this.setLatitude(position.coords.latitude);
    this.setLongitude(position.coords.longitude);
    this.setActive(true);

    resolve(this);
  };

  const whenGeolocationIsDisabled = () => {
    logger.message('The geolocation service failed.', 'error');
    this.setActive(false);

    resolve(this);
  };

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(whenGeolocationIsEnabled, whenGeolocationIsDisabled);
  } else {
    logger.message('Browser doesn\'t support Geolocation.', 'warning');
    this.setActive(false);

    resolve(this);
  }
}

export default class Geolocation {
  static instance = null;

  constructor({ lat, lng, google } = {}) {
    this.lat = lat;
    this.lng = lng;
    this.active = false;
    this.google = google;
  }

  getLatitude() {
    return this.lat;
  }

  getLongitude() {
    return this.lng;
  }

  isActive() {
    return this.active;
  }

  setActive(val) {
    this.active = val;
  }

  setLatitude(value) {
    this.lat = parseFloat(value);
  }

  setLongitude(value) {
    this.lng = parseFloat(value);
  }

  setLatitudeAndLongitude(lat, long) {
    this.setLatitude(lat);
    this.setLongitude(long);
  }

  getNavigatorGeolocation() {
    return new Promise(resolveNavigatorGeolocaiton.bind(this));
  }

  isCloseOfMyPosition({
    lat,
    lng,
    google,
    distance = 100,
  }) {
    const googleInstance = google || this.google;

    if (!googleInstance) {
      throw new Error('Google instance is not defined on Geolocation service');
    }

    const myPosition = new googleInstance.maps.LatLng(this.getLatitude(), this.getLongitude());
    const point = new googleInstance.maps.LatLng(lat, lng);
    const distanceBetweenPointAndMe = googleInstance.maps.geometry.spherical.computeDistanceBetween(point, myPosition);

    return distanceBetweenPointAndMe <= distance;
  }

  static create(params) {
    Geolocation.setInstance(new Geolocation(params));
  }

  static setInstance(instance) {
    Geolocation.instance = instance;
  }

  static getInstance() {
    return Geolocation.instance;
  }
}
